import React from "react";
import { Grid, Typography } from "@material-ui/core";
import useStyles from "./styles";

type Props = {
  firstName: string;
  lastName: string;
};

const UserSettingsHeader = ({ firstName, lastName }: Props) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction={"row"}
      justify={"flex-start"}
      className={classes.container}
    >
      <Grid item>
        <Typography className={classes.settingsText}>Settings</Typography>
        <Typography className={classes.name}>
          {firstName} {lastName}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default UserSettingsHeader;
